import dilpreet from "./dilpreet.schema.json";
import dashmeet from "./dashmeet.schema.json";
import jasmeet from "./jasmeet.schema.json";

export default {
  "resume.dashmeetart.com": dashmeet,
  "resume.dilpreetkaur.com": dilpreet,
  "resume.singhjasmeet.com": jasmeet
};
